<template>
    <div v-loading="loadingConfiguration">
        <el-card style="color:white; background: linear-gradient(45deg, rgb(85,85,85,1) 0%, rgba(36, 147, 147) 100%);">
        <el-col class="mb-10">
            <!-- <el-card> -->
                <h4>Webhook Configuration</h4>
                <el-form>
                    <el-select v-model="selectedPhoneNumber" placeholder="Select Phone Number" style="width:274px;">
                        <el-option
                        v-for="item in number"
                        :key="item"
                        :label="item"
                        :value="item">
                        </el-option>
                    </el-select>
                    &nbsp;
                    <el-button @click="getWebhook" type="primary" :loading="loadingButtonGetWebhook">Check webhook</el-button>
                    <el-button @click="doShowDialogUpdateWebhook" type="primary">Click for update webhook</el-button>
                    <!-- <el-button @click="dialogSetLimit=true" type="warning">Set Limit</el-button> -->
                </el-form>
            <!-- </el-card> -->
        </el-col>

        <!-- <el-card> -->
            <span v-if="selectedPhoneNumber">
                Phone Number Selected : {{selectedPhoneNumber}}
            </span>
            <span v-else>Phone Number Selected : -</span><br><br>
            <!-- <span v-if="webhookUrl!=null"> -->
                <div v-for="(hook, k) in webhookURL" :key="k" style="font-weight:bold; font-size:14px;" type="warning">
                    <span>Webhook URL : {{ hook.url }}
                        <!-- <span v-if="hook.url==''">-</span>
                        <span v-else>{{ hook.url }}</span> -->
                    </span> 
                    <br> 
                    <span>Send Status Allowed : {{ hook.send_status }}
                        <!-- <span v-if="hook.send_status==false" style="color: red; background-color: white; padding: 0 10px; border-radius: 3px;">{{ hook.send_status }}</span>
                        <span v-else style="color: green; background-color: white; padding: 0 10px; border-radius: 3px;">{{ hook.send_status }}</span> -->
                    </span>
                    <br><br>
                </div>
            <!-- </span> -->
            <!-- <span v-if="this.webhookURL!=null || this.webhookURL!='' || _isEmpty(this.webhookURL)">
                <el-tag style="font-weight:bold; font-size:16px;" type="warning">{{webhookURL}}</el-tag>
            </span> -->
            <!-- <span v-else>-</span> -->
            <br><br>
            <!-- <span v-if="selectedPhoneNumber" class="mt-20">
                <el-button @click="dialogUpdateWebhook=true" size="mini" type="primary">Update Webhook</el-button>
            </span>
            <span v-else>-</span> -->
        </el-card>

        <!-- <el-form class="mt-10">
            <el-input type="textarea" v-model="varToken" disabled></el-input>
        </el-form> -->
        
        <!-- <el-card class="mt-10"> -->
            <h4 class="mt-20">Phone Number &amp; Token List</h4>
            <!-- <el-button style="float:right;" @click="dialogUpdateToken=true" type="primary">Update Token</el-button> -->
            <div v-for="(data, key) in userDetail.detail" :key="key" class="mb-20" v-loading="loadingDetail">
                <el-card class="mb-10" style="width:100%;">
                    <!-- <el-button @click="doShowDialogLimit(key)" size="small" type="warning" class="fl-r ml-10">Limit Configuration</el-button> -->
                    <el-button @click="doShowDialogEditToken(key)" size="small" type="primary" class="fl-r ml-10">Re-Create Token</el-button>
                    <!-- <el-button @click="doShowDialogRateLimit(key)" size="small" type="success" class="fl-r ml-10">Rate Limit Configuration</el-button> -->
                    <el-button @click="blocked(data)" :disabled="disabled" :loading="loadingBlock" type="danger" size="small" class="fl-r">Block</el-button>
                    <el-button @click="active(data)" :disabled="disabled_act" :loading="loadingBlock" type="success" size="small" class="fl-r">Activate</el-button>
                    <el-tag type="default" style="font-size:14px;">{{data.number}}</el-tag>
                    <el-input
                        class="mt-10"
                        type="textarea"
                        rows="10"
                        disabled="disabled"
                        :autosize="{ minRows: 2, maxRows: 4}"
                        :value="data.token">
                    </el-input>
                    <el-button @click="refreshToken(data)" size="small" type="warning" class="fl-r ml-10 mt-10 mb-10" :loading="loadingRefresh">Refresh Token</el-button>
                </el-card>
            </div>
        <!-- </el-card> -->

        <el-dialog title="Update Webhook" :visible.sync="dialogUpdateWebhook">
            <el-form v-loading="loadingButtonGetWebhook">
                <el-form-item>
                    <!-- <el-input type="textarea" v-model="form_assign.selectedPhoneNumber" placeholder="Insert Credentials Token"></el-input> -->
                    <el-select @change="getWebhook()" v-model="selectedPhoneNumber" placeholder="Select Phone Number">
                        <el-option
                        v-for="item in number"
                        :key="item"
                        :label="item"
                        :value="item"
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <div v-for="(ob,i) in selectedURLUpdate" :key="i">
                        <input :style="{ width: '80%'}" style="margin-bottom: 5px; padding: 10px; border: 1px solid #dcdfe6; border-radius: 4px; color: #606266;" type="text" v-model="ob.url" placeholder="Insert Credentials URL Webhook"></input>
                        <div class="btn-del">
                            <el-button v-if="selectedURLUpdate.length > 1" @click="selectedURLUpdate.splice(i,1)" type="danger" icon="el-icon-delete" circle size="small"></el-button>
                        </div>
                    </div>
                    <el-button @click="selectedURLUpdate.push({url:''})" type="text">Add another url</el-button>
                </el-form-item>
                <el-form-item>
                    Allowed to send status?
                    <el-switch
                    style="display: block"
                    v-model="send_status"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-text="Yes"
                    inactive-text="No">
                    </el-switch>
                    <div v-if="send_status" style="margin-top: 20px;">
                        <el-form >
                        <el-form-item label="Send Status Url">
                            <div>
                                <el-input :style="{ width: '68%'}" style="margin-bottom: 5px;" v-model="selectedUrlAllowStatus" placeholder="Insert Credentials URL Status"></el-input>
                            </div>
                        </el-form-item>
                            <el-form-item label="Status Type">
                                <el-checkbox-group v-model="allowed_status">
                                    <el-checkbox class="checkbox-label" label="Interactive" name="type" :disabled="interDisable"></el-checkbox>
                                    <el-checkbox class="checkbox-label" label="HSM" name="type"></el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </el-form>
                    </div>
                    
                </el-form-item>
                <el-button type="primary" @click="updateWebhook" :loading="loadingBtnUpdateWebhook">Save</el-button>
                <el-button type="danger" @click="dialogUpdateWebhook=false">Close</el-button>
            </el-form>
        </el-dialog>

        <el-dialog title="Limit Configuration" :visible.sync="dialogSetLimit">
            <el-form>
                <el-form-item>
                    <el-input v-model="selectedPhoneNumberSetLimit" type="text" disabled="disabled" rows="5"></el-input>
                    <!-- <el-input type="textarea" v-model="form_assign.selectedPhoneNumber" placeholder="Insert Credentials Token"></el-input> -->
                    <!-- <el-select v-model="selectedPhoneNumberSetLimit" placeholder="Select Phone Number">
                        <el-option
                        v-for="item in number"
                        :key="item"
                        :label="item"
                        :value="item">
                        </el-option>
                    </el-select> -->
                </el-form-item>
                <el-form-item>
                    <!-- <el-input v-model="credToken" type="textarea" disabled="disabled" rows="5" class="mb-10"></el-input> -->
                    <el-input v-model="userToken" type="textarea" placeholder="Insert Credentials Token" disabled="disabled" rows="5"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-input v-model="limit" placeholder="Insert Credentials Limit (ex: 999)"></el-input>
                    <br>OR<br>
                    <el-button type="default" @click="setMaxLimit" :loading="loadingBtnSetMaxLimit">Click here to set MAX limit</el-button>
                </el-form-item>

                <el-button type="primary" @click="setLimit" :loading="loadingBtnSetLimit">Set</el-button>
                <el-button type="danger" @click="dialogSetLimit=false">Close</el-button>
                <el-button type="warning" @click="getInfoLimit" style="float: right;" :loading="loadingBtnGetInfo">Get</el-button>
            </el-form>
        </el-dialog>

        <el-dialog title="Rate Limit Configuration" :visible.sync="rateLimit.dialog">
            <el-form>
                <el-form-item>
                    <el-input v-model="rateLimit.number" type="text" disabled="disabled" rows="5"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-input v-model="rateLimit.value" placeholder="Insert Rate Limit (default: 20)"></el-input>
                    <small>Current Rate Limit: {{rateLimit.current}} </small>
                </el-form-item>

                <el-button type="primary" @click="setRateLimit" :loading="rateLimit.loadingBtn">Update</el-button>
                <el-button type="default" @click="rateLimit.dialog=false">Close</el-button>
            </el-form>
        </el-dialog>

        <el-dialog title="Create New Token" :visible.sync="dialogGenerateToken">
            <el-form>
                <h3>Are you sure to create new token for ?</h3>
                <el-input v-model="selectedNumber" type="text" disabled="disabled" rows="5" class="mb-10"></el-input>
                <el-input v-model="credToken" type="textarea" disabled="disabled" rows="5" class="mb-10"></el-input>
                <el-button class="mt-10" type="primary" @click="doGenerateToken" :loading="loadingBtnGenerateToken">Yes</el-button>
                <el-button type="danger" @click="dialogGenerateToken=false">No</el-button>
            </el-form>
        </el-dialog>

        <el-dialog title="Edit Token" :visible.sync="dialogUpdateToken">
            <el-form>
                <span>Phone Number</span>
                <el-form-item>
                    <el-select v-model="selectedNumber" placeholder="Select Phone Number">
                        <el-option
                        v-for="item in number"
                        :key="item"
                        :label="item"
                        :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
            
                <span>Old Token</span>
                <el-input v-model="credentialsOldToken" placeholder="Old token" type="textarea" style="width:100%;" class="mb-20 mt-10">
                </el-input>
                <span>New Token</span>
                <el-input v-model="credentialsNewToken" placeholder="Insert new token" type="textarea" class="mt-10"></el-input>
                <br><br>
                <el-button type="primary" @click="saveUpdateToken" :loading="loadingBtn">Save</el-button>
            </el-form>
        </el-dialog>

    </div>
</template>
<script>
import api from '@/networkClient'
import config from '@/config'
const moment = require('moment')

export default {
    props: {
        waUserDetail: {
            type: Object,
            default: {}
        },
        datahsm: {
            type: Array
        },
        services: {
            type: Object
        },
        customerName: {
            type: String
        },
        dataUser:{
            type: Object
        },
        loadingPage:{
            type: Boolean,
            default: false
        }
    },
    name: "configuration",
    data() {
        return {
            interDisable: false,
            loadingRefresh: false,
            send_status: true,
            disabled: false,
            disabled_act: false,
            default_send_status: false,
            varToken:'-',
            dialogUpdateWebhook: false,
            dialogSetLimit: false,
            dialogGenerateToken: false,
            dialogUpdateToken: false,
            generateToken:{
                token:''
            },
            rateLimit: {
                dialog: false,
                number: '',
                value: null,
                current: 20,
                loadingBtn: false
            },
            selectedPhoneNumberSetLimit: '',
            selectedPhoneNumberToUpdateToken: '',
            selectedTokenToUpdate: '',
            selectedNumber: '',
            credentialsOldToken:'',
            credentialsNewToken:'',
            userToken: '',
            limit: '',
            userDetail: this.waUserDetail,
            selectedTokenUpdate:'',
            selectedURLUpdate:[{url:""}],
            selectedUrlAllowStatus: '',
            allowed_status:['Interactive', 'HSM'],
            data:'',
            listServices: this.services,
            loadingConfiguration: false,
            selectedPhoneNumber: '',
            selectedEditNumber: 0,
            showAlertMessage: false,
			showAlertError: false,
            loadingDetail:false,
            loadingConfiguration:false,
            loadingSetLimit:false,
            loadingGenerateToken: false,
            loadingTokenList:false,
            loadingBtn:false,
            loadingBtnSetLimit:false,
            loadingBtnSetMaxLimit:false,
            loadingBtnGenerateToken: false,
            loadingButtonGetWebhook:false,
            loadingBtnUpdateWebhook:false,
            loadingBtnGetInfo: false,
            loadingUpdateToken: false,
            loadingNumber:false,
            modalUpdateWebhook:false,
            postmanSetting:false,
            number:[],
            token: [ { token: [] } ],
            user:[],
            // webhookURL:'-',
            webhookURL: [],
            form_assign:{
                token_whatsapp:'',
                url:''
            },
            credNumber: '',
            credToken: '',
            credLimit: '',
            maxlimit: 'max',
            loadingBlock: false
            // token:[]
        }
    },
    methods: {
        doShowDialogUpdateWebhook(){
            this.selectedUrlAllowStatus = '',
            this.dialogUpdateWebhook = true
            if(this.selectedPhoneNumber != ''){
                this.getWebhook()
            }
        },
        doShowDialogEditToken(key){
            this.dialogGenerateToken = true
            this.selectedNumber = this.token[key].number
            this.selectedPhoneNumberToUpdateToken = this.token[key].token
        },
        doShowDialogLimit(key){
            this.dialogSetLimit = true
            this.selectedPhoneNumberSetLimit = this.token[key].number
            this.userToken = this.token[key].token
        },
        doShowDialogRateLimit(key){
            this.rateLimit.dialog = true
            this.rateLimit.number = this.token[key].number
            this.rateLimit.value = null
            this.rateLimit.current = this.token[key].rate_limit || 20
        },
        async getWebhook(){
            if(_.isEmpty(this.selectedPhoneNumber)){
                this.$message.error({
                    showClose: false,
                    message: 'Please select phone number'
                });
                return
            }
            this.send_status = false
            this.allowed_status = ['Interactive','HSM']
            this.selectedUrlAllowStatus = ''
            this.selectedURLUpdate = [{url:""}]
            this.loadingButtonGetWebhook = true
            let custId = this.$route.params.consumen
			await api({
				url: config.baseApi + 'consumen/' + custId +'/get_webhook',
				method: 'post',
				data: {
                    "number":this.selectedPhoneNumber
				}
			}).then(res => {
                if(res.data.ec != 200){
                    this.$swal(this.$t('error'), this.$t('error_text'), "error")
                }
                else{
                    
                    this.webhookURL = res.data.data.webhook
                    let fill = this.services.services.filter(el => el.number == this.selectedPhoneNumber)
                    if (fill[0]) {
                       this.interDisable = fill[0].service.find(element => element.name == 'helpdesk') ? true: false;

                       if (this.interDisable) {
                           this.allowed_status = this.allowed_status.filter(el => el != 'Interactive')
                       }
                    //    else {
                    //        this.allowed_status = ['Interactive', 'HSM']
                    //    }
                    }
                    // console.log('fill', fill);
                    this.webhookURL.forEach((element,i) => {
                        this.send_status = element.send_status
                        this.selectedURLUpdate[i] = {url : element.url}
                        if (element.custom_forward) {
                            this.selectedUrlAllowStatus = element.custom_forward.url || element.url
                            if (!element.custom_forward.statusInteractive) this.allowed_status = this.allowed_status.filter(el => el != 'Interactive')
                            if (!element.custom_forward.statusHsm) this.allowed_status = this.allowed_status.filter(el => el != 'HSM')
                        }
                    });

                    if (this.selectedURLUpdate[0] && !this.selectedUrlAllowStatus) {
                        this.selectedUrlAllowStatus = this.selectedURLUpdate[0].url
                    }
                    // console.log(this.selectedUrlAllowStatus);
                }
                // this.send_status = res.data.data
                // this.loadUser()
                // console.log('get webhook res',res)
			}).catch(err => {
                this.$swal(this.$t('error'), this.$t('error_text'), "error")
                return err
            })
            this.loadingButtonGetWebhook = false
        },
        refreshToken(props){
            console.log('props',props)
            this.$confirm('Are you sure for this action?', 'Warning', {
                confirmButtonText: 'Yes, sure!',
                cancelButtonText: 'Cancel',
                type: 'warning',
                center: true
            }).then(() => {
                this.loadingRefresh = true
                api({
                    url: config.baseApi + 'consumen/refresh_token',
                    method: 'post',
                    data: {
                        "token":props.token
                    }
                }).then(response => {
                    console.log("response for refresh token",response)
                    this.$message({
                        type: 'success',
                        message: 'Token has been refresh'
                    });
                    this.loadingRefresh = false
                }).catch(error => {
                    this.loadingBlock = false
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Refresh token canceled'
                });
            });
            // api({
            //     url: config.baseApi + 'consumen/refresh-token',
            //     method: 'post',
            //     data: {
            //         token: props.row.token
            //     }
            // }).then(res => {
            //     console.log("response refresh token",res)
            // }).catch(err => {
            //     console.log('error refresh token',err)
            // })
        },
        async updateWebhook(){
            if(_.isEmpty(this.selectedPhoneNumber)){
                this.$message.error({
                    showClose: false,
                    message: 'All field is required'
                });
                return
            }
            if(this.selectedURLUpdate.filter(el => el.url == "").length > 0){
                this.$message.error({
                    showClose: false,
                    message: 'All field is required'
                });
                return
            }

            if (this.send_status == true) {
               if (!this.selectedUrlAllowStatus) {
                   this.$message.error({
                    showClose: false,
                    message: 'All field is required'
                    });
                    return
               } 
            }


            this.$confirm(`Make sure your webhook url is correct ! Continue?`, 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning',
                center: true
			}).then(async () => {
                this.loadingBtnUpdateWebhook = true
                let custId = this.$route.params.consumen
                await api({
                    url: config.baseApi + 'consumen/'+custId+'/update_webhook',
                    method: 'post',
                    data: {
                        "number":this.selectedPhoneNumber,
                        "url":this.selectedURLUpdate,
                        "send_status":this.send_status,
                        "custom_forward": {
                            "status_type": this.allowed_status.length > 0 && this.send_status == true ? this.allowed_status.map(el => el.toLowerCase()) : [],
                            "url" : this.selectedUrlAllowStatus || this.selectedURLUpdate[0].url
                        }
                    }
                }).then(res => {
                    this.loadingProduct=true
                    if(res.data.ec != 200){
                        this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
                        this.dialogUpdateWebhook = false
                    } else {
                        this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
                        this.dialogUpdateWebhook = false
                    }
                }).catch(err => {
                    this.$swal(this.$t('error'), this.$t('error_text'), "error")
                    return err
                })
                this.loadingBtnUpdateWebhook=false
            })
        },
        async loadWA() {
            this.loadingNumber = true
            let custId = this.$route.params.consumen
            await api({
                method: 'post',
                url: config.baseApi +'user/'+custId+'/detail_number'
            }).then(result => {
                this.number = result.data.data
                this.loadService()
            }).catch(error => {
                this.showAlertError = true
            })
            this.loadingNumber = false
        },
        async loadUser() {
            this.loadingConfiguration = true
            let custId = this.$route.params.consumen
            await api({
                method: 'post',
                url: config.baseApi +'user/'+custId+'/detail_number_token'
            }).then(result => {
                this.token = result.data.data
                // console.log('token',this.token)
                this.token.forEach(element => {
                    this.credNumber = element.number
                    this.credToken = element.token
                    // console.log('number', this.credNumber)
                });
                
                // this.token.push({
                //     number: result.number,
                //     token: result.token
                // })
                // $cookies.set('number', this.token[0].number)
                // $cookies.set('credentials_token', this.token)
                if(result.data.ec == 200){
                    this.userDetail = { detail: [], hsm: [], sender: [] }
                    this.showFormMessage = true
                    let tempHsm = []
                    let tempSender = []
                    _.forEach(result.data.data, res => {
                        _.forEach(res.hsm, hsm => {
                            tempHsm.push(hsm)
                        })
                        tempSender.push(res.phoneNumber)
                        this.userDetail.detail.push({ number: res.number, token: res.token })
                    })
                    this.userDetail.hsm = _.uniqBy(tempHsm, 'name')
                    this.userDetail.sender = _.uniq(tempSender)
                    this.sender = this.userDetail.sender[0]
                    
                } else if(result.data.ec == 400 && result.data.message == "not_subscribe"){
                    this.showAlertMessage = true
                } else {
                    this.showAlertError = true
                }
            }).catch(error => {
                this.showAlertError = true
            })
            this.loadingConfiguration = false
        },

        async setLimit(){
            if(_.isEmpty(this.selectedPhoneNumberSetLimit) || _.isEmpty(this.userToken) || _.isEmpty(this.limit)){
                this.$message.error({
                    showClose: false,
                    message: 'All field is required'
                });
                return
            }
            this.loadingBtnSetLimit = true
			await api({
				url: config.baseApi + 'user/service/addLimit',
				method: 'post',
				data: {
                    "token":this.userToken,
                    "sender":this.selectedPhoneNumberSetLimit.replace(/0/, '62'),
                    "limit":parseInt(this.limit)
				}
			}).then(res => {
                this.loadingSetLimit=true
				if(res.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
					this.dialogSetLimit = false
				} else {
					this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
					this.dialogSetLimit = false
				}
			}).catch(err => {
                return err
            })
            this.loadingBtnSetLimit=false
        },

        async setRateLimit(){
            if(_.isEmpty(this.rateLimit.number) || _.isEmpty(this.rateLimit.value)){
                this.$message.error({
                    showClose: false,
                    message: 'All field is required'
                });
                return
            }

            if(Number.isNaN(parseInt(this.rateLimit.value))){
                this.$message.error({
                    showClose: false,
                    message: 'Rate Limit should be a number'
                });
                return
            }

            if(["20", "40", "80", "160", "320"].indexOf(this.rateLimit.value) == -1){
                this.$message.error({
                    showClose: false,
                    message: 'Rate Limit not valid. Allowed: 20, 40, 80, 160 or 320'
                });
                return
            }
            this.rateLimit.loadingBtn = true
            await api({
                url: config.baseApi + `wa/${this.$route.params.consumen}/rate-limit`,
                method: "patch",
                data: {
                    number: this.rateLimit.number,
                    limit: this.rateLimit.value
                }
            }).then(response => {
                if(response.data.ec == 200){
                    this.rateLimit.dialog = false
                    this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
                    this.loadUser()
                } else {
                    this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
                }
            }).catch(err => {

            })
            this.rateLimit.loadingBtn = false
        },

        async setMaxLimit(){
            // if(_.isEmpty(this.selectedPhoneNumberSetLimit) || _.isEmpty(this.userToken) || _.isEmpty(this.limit)){
            //     this.$message.error({
            //         showClose: false,
            //         message: 'All field is required'
            //     });
            //     return
            // }
            this.loadingBtnSetMaxLimit = true
			await api({
				url: config.baseApi + 'user/service/addLimit',
				method: 'post',
				data: {
                    "token":this.userToken,
                    "sender":this.selectedPhoneNumberSetLimit.replace(/0/, '62'),
                    "limit":this.maxlimit
				}
			}).then(res => {
                this.loadingSetLimit=true
				if(res.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
					this.dialogSetLimit = false
				} else {
					this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
					this.dialogSetLimit = false
				}
			}).catch(err => {
                return err
            })
            this.loadingBtnSetMaxLimit=false
        },

        async doGenerateToken(){
            if(_.isEmpty(this.selectedPhoneNumberToUpdateToken)){
                this.$message.error({
                    showClose: false,
                    message: 'Credentials token is required'
                });
                return
            }
            // this.loadingDetail = true
            this.loadingBtnGenerateToken = true
			await api({
				url: config.baseApi + 'user/generateToken',
				method: 'post',
				data: {
                    "token":this.selectedPhoneNumberToUpdateToken,
				}
			}).then(res => {
                this.loadingDetail = true
				if(res.data.ec != 200){
                    this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
                    this.loadingDetail = false
                    this.loadingBtnGenerateToken = false
                    this.dialogGenerateToken = false
				} else {
                    // console.log('new token',res.data.data.data.token)
                    this.varToken = res.data.data.data.token
                    $cookies.set('new_token', this.varToken)
                    this.saveUpdateToken()
                    // this.$swal(this.$t('success'), this.$t('success'), "success").then(() => {
                    //     this.dialogGenerateToken = false
                    //     this.loadUser()
                    // })
                    this.$swal(this.$t('success'), '<h4>Congratulation, you get a new token : </h4>'+'<h5>'+res.data.data.data.token+'</h5>', "success").then(() => {
                        this.dialogGenerateToken = false
                        this.loadingDetail = true
                        this.loadUser()
                        this.clear()
                        this.loadingDetail = false
                    })
                    // this.loadUser()
                    // this.loadingDetail = true
                    // this.loadingConfiguration = true
                    // this.loadingBtnGenerateToken = false
                    this.dialogGenerateToken = false
                    this.loadingTokenList = true
                    // location.reload();
                    // $route.router.reload()
				}
			}).catch(err => {
                return err
            })
            // this.loadingDetail = false
            this.loadingConfiguration = false
            this.loadingBtnGenerateToken = false
            this.loadingTokenList = false
        },

        async saveUpdateToken(){
            this.loadingBtn = true
            let custId = this.$route.params.consumen
			await api({
				url: config.baseApi + 'consumen/'+custId+'/service_user',
				method: 'patch',
				data: {
                    "phone_number":this.selectedNumber,
                    "oldToken":this.credToken,
                    "newToken":$cookies.get('new_token', this.varToken)
				}
			}).then(res => {
                this.loadingDetail = true
                this.loadingTokenList=true
				if(res.data.ec != 200){
					// this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
					// this.dialogUpdateToken = false
                    this.loadingDetail = true
                    this.loadingTokenList = true
				} else {
					// this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
					// this.dialogUpdateToken = false
                    this.loadingDetail = true
                    this.loadingTokenList = true
                    // location.reload();
                    // $route.router.reload()
				}
			}).catch(err => {
                return err
            })
            this.loadingDetail = false
            // this.loadingBtn=false
            this.loadingTokenList = false
        },

        copyToClipboard(){
            let token = document.querySelector('#token')
            token.select()
            try {
                var successful = document.execCommand('copy');
                this.$message.success({
                    showClose: true,
                    duration: 3000,
                    message: "Copied to clipboard"
                });
            } catch(err){
                console.log(err)
            }
            window.getSelection().removeAllRanges()
        },

        async getInfoLimit(){
            if(_.isEmpty(this.selectedPhoneNumberSetLimit) || _.isEmpty(this.userToken)){
                this.$message.error({
                    showClose: false,
                    message: 'All field is required'
                });
                return
            }
            this.loadingBtnGetInfo = true
            await api({
                url: config.baseApi + 'getLimit',
                method: 'get',
                params: {
                    "token":this.userToken,
                    "sender":this.selectedPhoneNumberSetLimit.replace(/0/, '62')
                }
            }).then(res => {
                // console.log('response limit data',res.data.data)
                this.loadingSetLimit=true
                if(res.data.ec != 200){
                    this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
                    this.dialogSetLimit = false
                } else {
                    this.$swal(this.$t('success'), "Remaining limit is "+"( "+res.data.data+" )", "success").then(this.clear())
                    this.dialogSetLimit = false
                }
            }).catch(err => {
                return err
            })
            this.loadingBtnGetInfo=false
        },

        blocked(k){
            console.log("Block key",k)
            this.$confirm('Are you sure for this action?', 'Warning', {
                confirmButtonText: 'Yes, sure!',
                cancelButtonText: 'Cancel',
                type: 'warning',
                center: true
            }).then(() => {
                this.loadingBlock = true
                api({
                    url: config.baseApi + 'wa/blocked',
                    method: 'post',
                    params: {
                        "token":k.token,
                        "action":"blocked"
                    }
                }).then(response => {
                    console.log("response for blocked",response)
                    this.$message({
                        type: 'success',
                        message: 'Block success'
                    });
                    this.loadingBlock = false
                    this.disabled = true
                    this.disabled_act = false
                }).catch(error => {
                    this.loadingBlock = false
                    this.disabled = false
                    this.disabled_act = true
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Block canceled'
                });
            });
        },
        
        active(k){
            console.log("Activated key",k)
            this.$confirm('Are you sure for this action?', 'Warning', {
                confirmButtonText: 'Yes, sure!',
                cancelButtonText: 'Cancel',
                type: 'warning',
                center: true
            }).then(() => {
                console.log("token",k.token)
                this.loadingBlock = true
                api({
                    url: config.baseApi + 'wa/blocked',
                    method: 'post',
                    params: {
                        "token":k.token,
                        "action":"active"
                    }
                }).then(response => {
                    console.log("response for activate",response)
                    this.$message({
                        type: 'success',
                        message: 'Activate success'
                    });
                    this.loadingBlock = false
                    this.disabled_act = true
                    this.disabled = false
                }).catch(error => {
                    this.loadingBlock = false
                    this.disabled = true
                    this.disabled_act = false
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Activate canceled'
                });
            });
        },

        clear(){
            this.selectedPhoneNumber=''
            this.selectedURLUpdate=[{url:""}]
            this.selectedPhoneNumberSetLimit=''
            this.userToken=''
            this.limit=''
            this.generateToken.token=''
            this.selectedPhoneNumberToUpdateToken=''
            this.credentialsOldToken=''
            this.credentialsNewToken=''
            this.varToken=''
            this.webhookURL='-'
            this.rateLimit =  {
                dialog: false,
                number: '',
                value: null,
                current: 20,
                loadingBtn: false
            }
        }
    },
    async mounted() {
        // this.loadWA()
        this.loadUser()
        // this.loadService()
        // this.getWebhook()
    },
    watch: {
        loadingPage: function(){
            // console.log("watchh")
            this.loadingTokenList = this.loadingPage
            this.loadingConfiguration = this.loadingPage
            this.number = this.waUserDetail.sender
            this.userDetail = this.dataUser
        }
    }
}
</script>

<style lang="scss">
    .el-form-item__label {
        font-weight: 600;
    }

    .checkbox-label {
        margin-left: 1.6em;
        .el-checkbox__label {
            color: #606266;
        }
    }
</style>
<style lang="scss" scoped>

.btn-del {
	margin-left: 10px;
	display: inline-block;
}
</style>
